import script from "./ClassicPasswordStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicPasswordStep.vue?vue&type=script&setup=true&lang=js"

import "./ClassicPasswordStep.vue?vue&type=style&index=0&id=6b34c685&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/keepyoursight/keepyoursight/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b34c685"]])

export default __exports__